import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tag } from '../Tag';
import { ToolOutlined } from '@ant-design/icons';
import { SectionIcon } from '../SectionIcon';

// the inspection's condition summary, or (`title`) the dealer documents' service summary
export const ConditionSummary = ({ rows, title }) => {
    const { t } = useTranslation('reportPage');

    return (
        <section id="condition" className="card side-card" aria-labelledby="condition-title">
            <h2 id="condition-title" className="h2">
                <SectionIcon icon={ToolOutlined} />
                {title || t('layout.conditionSummary')}
            </h2>
            <dl className="kv-list">
                {rows.map(row => (
                    <div className="kv" key={row.label}>
                        <dt>{row.label}</dt>
                        <dd>{row.tone ? <Tag tone={row.tone}>{row.value}</Tag> : row.value}</dd>
                    </div>
                ))}
            </dl>
        </section>
    );
};
